<template>
	<div class="space">
		<div class="tab-list">
			<div class="mid">
				<span>我的收藏</span>
			</div>
		</div>
		<div class="content">
			<div class="seaech-tab">
				<div class="tab-list">
					<div class="mid">
						<span @click="changeType(i.code)" :class="activeCode===i.code ? 'active':'' " v-for="i in typeList" :key="i.code">{{i.name}}</span>
					</div>
				</div>
			</div>
			<div class="space-table">
				<!-- 表格 -->
				<el-table element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.9)" v-loading="isTableLoading" :data="dataList" stripe style="width: 100%" :header-cell-style="{background:'#EFEFEF'}">
					<el-table-column prop="title" label="标题" width="170"></el-table-column>
					<el-table-column prop="browseCount" label="浏览次数"></el-table-column>
					<el-table-column prop="downloadCount" label="下载次数"></el-table-column>
					<el-table-column prop="collectCount" label="收藏次数"></el-table-column>

					<el-table-column prop="createTime" label="创建时间"></el-table-column>

					<el-table-column prop="name" label="操作">
						<template slot-scope="scope">
							<el-button type="text" @click="goDetail(scope.row)">查看详情</el-button>
						</template>
					</el-table-column>
				</el-table>
				<pagination :pageObj="pageObj" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></pagination>
			</div>
		</div>
	</div>
</template>

<script>
import { postData, getData, postJson } from "@/http/fetch.js";
import { mapState } from "vuex";
import { mapFileIcon, lookFile, downloadUrlFile } from "@/utils/index.js";
import Pagination from "@/components/Pagination.vue";
export default {
	components: {
		Pagination
	},
	computed: {
		...mapState(["userInfo", "resOptions"])
	},
	data() {
		return {
			isTableLoading: false,
			activeCode: "",
			typeList: [
				{ code: "", name: "全部" },
				{ code: "design", name: "教学设计" },
				{ code: "articles", name: "学术文章" },
				{ code: "radiation", name: "示范辐射" }
			],

			dataList: [],
			form: {},

			pageObj: {
				current: 1,
				total: 0,
				size: 10,
				sizeList: [5, 10, 15, 20]
			}
		};
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.selectData();
		},
		async selectData() {
			this.isTableLoading = true;
			let { total, records } = await postJson(
				"/collectInfo/getTeacherCollectInfoList",
				{
					operatorId: this.userInfo.userId,
					pageNum: this.pageObj.current,
					pageSize: this.pageObj.size,
					module: this.activeCode
				}
			);
			this.pageObj.total = total;
			this.dataList = records;
			this.isTableLoading = false;
		},

		changeType(code) {
			this.activeCode = code;
			this.pageObj.current = 1;
			this.selectData();
		},
		goDetail(row) {
			if (row.module == "design") {
				this.$router.push({
					name: "teachingDesignDetail",
					params: { id: row.id }
				});
			} else if (row.module == "articles") {
				this.$router.push({
					name: "academicEssayDetail",
					params: { id: row.id }
				});
			} else if (row.module == "radiation") {
				this.$router.push({
					name: "demonstrationRadiationDetail",
					params: { id: row.id }
				});
			}
		},
		//分页
		handleSizeChange(pageSize) {
			this.pageObj.current = 1;
			this.pageObj.size = pageSize;
			this.selectData();
		},
		handleCurrentChange(curPage) {
			this.pageObj.current = curPage;
			this.selectData();
		}
	},
	watch: {}
};
</script>

<style lang="less" scoped>
.space {
	.tab-list {
		background-color: #fff;
		padding: 20px 0px;
		border-bottom: 2px solid #eee;
		span {
			font-size: 17px;
			padding: 6px 8px;
			border-radius: 8px;
			margin-left: 100px;
			color: @color;
		}
	}
	.content {
		background-color: #fff;
		margin-top: 15px;
		padding: 10px 0px;
		.seaech-tab {
			.tab-list {
				padding: 13px 0px;
				border-bottom: 3px solid #eee;
				span {
					font-size: 14.5px;
					cursor: pointer;
					padding: 6px 8px;
					border-radius: 8px;
					margin: 0px 5%;
					color: rgb(54, 53, 53);
				}
				span:hover {
					color: @color;
					//background-color: @hover-bg;
				}
				.active {
					color: @color;
					//background-color: @hover-bg;
				}
			}
		}
		.space-table {
			padding-bottom: 30px;
			padding: 0px 15px;
			margin-top: 20px;
		}
	}
}
</style>
